import { PaperActions } from "../action-types/paperActionType";


const initialState = {
    PaperData: {},
};

export default function paperDataReducer(state = initialState, action) {
    switch (action.type) {
        case PaperActions.GET_PAPER_DATA:
            return {
                ...state,
            };
        case PaperActions.SET_PAPER_DATA:
            return {
                ...state,
                PaperData: action.payload,
            };
        default:
            return state;
    }
}
